/**
 * Phase 1.7 — Settings → Profile.
 *
 * Read-only profile view today (the existing user/auth surface is owned by
 * Phase 1.1 and a write API isn't in scope here). Layout follows the
 * Settings sub-sidebar pattern.
 */

import { useAuthStore } from '@/lib/auth';
import { Card } from '@/components/v2';

export function SettingsProfilePage(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const ranch = useAuthStore((s) => s.ranch);
  if (!user) return <div />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl text-charcoal dark:text-charcoal-dark">Profile</h1>
        <p className="mt-1 text-muted-foreground">{user.name}, your account on {ranch?.name ?? 'this ranch'}.</p>
      </div>
      <Card title="Account">
        <dl className="divide-y divide-border">
          <Row label="Name" value={user.name} />
          <Row label="Email" value={user.email} />
          <Row label="Role" value={user.role} />
          <Row label="Ranch" value={ranch?.name ?? '–'} />
        </dl>
      </Card>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }): JSX.Element {
  return (
    <div className="grid grid-cols-3 py-3 first:pt-0 last:pb-0">
      <dt className="font-mono text-2xs uppercase tracking-wider text-muted-foreground">{label}</dt>
      <dd className="col-span-2 text-sm">{value}</dd>
    </div>
  );
}
